<div class="credit-assign-container">
  <!-- Left Side - Budget & Create Group -->
  <div class="left-side">
    <!-- Walk-in Info Block -->
    <div *ngIf="isWalkIn" class="walkin-info-block">
      <mat-icon class="walkin-icon">info</mat-icon>
      <div class="walkin-content">
        <div class="walkin-title">PAŽNJA: WALK-IN REZERVACIJA</div>
        <div class="walkin-subtitle">Ovo je walk-in rezervacija - gost plaća na licu mjesta</div>
      </div>
    </div>

    <!-- Already Checked-In Info Block -->
    <div *ngIf="alreadyCheckedIn" class="walkin-info-block already-checked-in-block">
      <mat-icon class="walkin-icon">check_circle</mat-icon>
      <div class="walkin-content">
        <div class="walkin-title">CHECK-IN JE VEĆ ZAVRŠEN</div>
        <div class="walkin-subtitle">Grupe su već poslane u Gastro. Za dodavanje ili uklanjanje narukvica koristite sljedeći korak (Pošalji).</div>
      </div>
    </div>

    <!-- Budget Panel -->
    <div class="budget-panel">
      <div class="panel-header">
        <mat-icon class="header-icon">account_balance_wallet</mat-icon>
<!--        <h2 class="panel-title">Budžet</h2>-->
        <mat-chip class="mb-2">{{ package }}</mat-chip>
      </div>
<!--      <div>-->
<!--        <mat-chip class="mb-2">{{ package }}</mat-chip>-->
<!--      </div>-->

      <div class="budget-cards">
        <div class="budget-card main-card">
          <mat-icon class="card-icon">payments</mat-icon>
          <div class="card-content">
            <div class="card-label">Ukupno plaćeno na rezervaciji</div>
            <div class="card-value">{{ dailyBudget.toFixed(2) }} {{ currency }}</div>
          </div>
        </div>

<!--        <div class="budget-card discount-card">-->
<!--          <mat-icon class="card-icon">local_offer</mat-icon>-->
<!--          <div class="card-content">-->
<!--            <div class="card-label">Cijena ležaljki s popustom</div>-->
<!--            <div class="card-value discount-value">{{ (dailyBudget - availableBudget).toFixed(2) }} {{ currency }}</div>-->
<!--          </div>-->
<!--        </div>-->

<!--        <div class="budget-card credit-card">-->
<!--          <mat-icon class="card-icon">credit_card</mat-icon>-->
<!--          <div class="card-content">-->
<!--            <div class="card-label">Dostupan kredit na narukvice</div>-->
<!--            <div class="card-value credit-value">{{ availableBudget.toFixed(2) }} {{ currency }}</div>-->
<!--            <div class="card-badge">{{ budgetPercentage }}%</div>-->
<!--          </div>-->
<!--        </div>-->
      </div>
    </div>

    <!-- Create Group Panel -->
    <div class="create-group-panel">
      <div class="panel-header">
        <mat-icon class="header-icon">group_add</mat-icon>
        <h2 class="panel-title">Nova grupa</h2>
      </div>

      <div class="group-form">
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>
            <mat-icon class="label-icon">group</mat-icon>
            Naziv grupe
          </mat-label>
          <input matInput [(ngModel)]="newGroupName" placeholder="npr. Obitelj Horvat" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field">
          <mat-label>
            <mat-icon class="label-icon">person</mat-icon>
            Kontakt osoba
          </mat-label>
          <input matInput [(ngModel)]="newGroupContact" placeholder="Ime i prezime" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field">
          <mat-label>
            <mat-icon class="label-icon">email</mat-icon>
            Email
          </mat-label>
          <input matInput [(ngModel)]="newGroupEmail" type="email" placeholder="email@example.com" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field">
          <mat-label>
            <mat-icon class="label-icon">add_circle</mat-icon>
            Prekoračenje (EUR)
          </mat-label>
          <input matInput [(ngModel)]="newGroupOverdraft" type="number" min="0" step="1" placeholder="0.00" />
        </mat-form-field>

        <button
          mat-raised-button
          color="primary"
          (click)="createGroup()"
          [disabled]="loading || !newGroupName"
          class="btn-create-group"
        >
          <mat-icon *ngIf="!loading">add_circle</mat-icon>
          <mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
          <span *ngIf="!loading">Kreiraj grupu</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Right Side - Groups -->
  <div class="right-side">

    <div>

      <!-- Unassigned Chairs -->
      <div *ngIf="groups.length > 0" class="chairs-panel">
        <div class="panel-header">
          <mat-icon class="header-icon">event_seat</mat-icon>
          <h2 class="panel-title">Dostupne ležaljke</h2>
        </div>

        <div *ngIf="unassignedChairs.length > 0" class="chips-container">
          <mat-chip
            *ngFor="let chair of unassignedChairs"
            class="chair-chip unassigned-chip"
            (click)="assignChairToSelectedGroup(chair)"
          >
            <div class="chair-inline-content">
              <mat-icon class="chair-seat-icon">event_seat</mat-icon>
              <div class="chair-info">
                <span class="chair-name">{{ chair.number || chair.type }}</span>

<!--                <span class="chair-budget">{{ chair.priceWithDiscount?.toFixed(2) }} EUR</span>-->
                <span class="chair-budget">{{ chair.price?.toFixed(2) }} EUR</span>

              </div>
            </div>
          </mat-chip>
        </div>

        <div *ngIf="unassignedChairs.length === 0" class="all-chairs-assigned">
          <mat-icon class="assigned-icon">check_circle</mat-icon>
          <p>Sve ležaljke su dodijeljene</p>
        </div>
      </div>

    </div>
    <div class="groups-panel">
      <div class="groups-header">
        <div class="header-content">
          <mat-icon class="header-icon">groups</mat-icon>
          <div>
            <h2 class="panel-title">Grupe</h2>
            <p class="panel-subtitle">{{ groups.length }} {{ groups.length === 1 ? 'grupa' : 'grupe' }}</p>
          </div>
        </div>
        <div class="budget-summary">
          <div class="summary-item">
            <span class="summary-label">Ukupno</span>
            <span class="summary-value">{{ totalPriceUsed.toFixed(2) }} {{ currency }}</span>
          </div>
        </div>
      </div>

      <!-- Empty State -->
      <div *ngIf="groups.length === 0" class="empty-state">
        <div class="empty-state-content">
          <mat-icon class="empty-icon">group_off</mat-icon>
          <h3>Nema kreiranih grupa</h3>
          <p>Kreirajte grupu za dodjelu ležaljki i narukvica</p>
        </div>
      </div>

      <!-- Groups List -->
      <mat-accordion multi="true" class="groups-accordion" *ngIf="groups.length > 0">
        <mat-expansion-panel
          *ngFor="let group of groups"
          [expanded]="group.isExpanded"
          class="group-expansion-panel"
        >
          <mat-expansion-panel-header class="group-panel-header">
            <mat-panel-title>
              <div class="group-header">
                <div class="group-info">
                  <span class="group-name">{{ group.name }}</span>
                  <span class="group-id">ID: {{ group.id }}</span>
                </div>
                <div class="group-budget-info">
                  <div class="budget-stat">
                    <mat-icon class="stat-icon">payments</mat-icon>
                    <span class="stat-label">Cijena:</span>
                    <span class="stat-value">{{ getGroupPrice(group).toFixed(2) }} {{ currency }}</span>
                  </div>
<!--                  <div class="budget-stat primary">-->
<!--                    <mat-icon class="stat-icon">credit_card</mat-icon>-->
<!--                    <span class="stat-label">Kredit:</span>-->
<!--                    <span class="stat-value">{{ group.budget.toFixed(2) }} {{ currency }}</span>-->
<!--                  </div>-->
                  <div class="budget-stat overdraft-stat">
                    <mat-icon class="stat-icon">trending_up</mat-icon>
                    <span class="stat-label">Prekoračenje:</span>
                    <span class="stat-value overdraft-value">{{ group.overdraft?.toFixed(2) ?? '0.00' }} {{ currency }}</span>
                  </div>
                </div>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="group-details">
            <!-- Chairs Section -->
            <div class="detail-section">
              <div class="section-header">
                <h4>
                  <mat-icon>event_seat</mat-icon>
                  Ležaljke
                </h4>
                <span class="section-count">{{ group.sunbeds.length }}</span>
              </div>
              <div class="chips-container">
                <mat-chip
                  *ngFor="let sunbed of group.sunbeds"
                  class="chair-chip assigned-chip"
                >
                  <div class="chair-inline-content">
                    <mat-icon class="chair-seat-icon">event_seat</mat-icon>
                    <div class="chair-info">
                      <!-- Edit mode -->
                      <ng-container *ngIf="editingSunbedId === sunbed.id">
                        <input
                          type="text"
                          [(ngModel)]="editedSunbedNumber"
                          (keydown)="onSunbedEditKeyDown($event, group.id, sunbed.id)"
                          [id]="'sunbed-edit-' + sunbed.id"
                          class="sunbed-edit-input"
                        />
                        <button
                          mat-icon-button
                          (click)="saveSunbedNumber(group.id, sunbed.id)"
                          class="sunbed-edit-btn save-btn"
                        >
                          <mat-icon>check</mat-icon>
                        </button>
                        <button
                          mat-icon-button
                          (click)="cancelSunbedEdit()"
                          class="sunbed-edit-btn cancel-btn"
                        >
                          <mat-icon>close</mat-icon>
                        </button>
                      </ng-container>
                      <!-- Display mode -->
                      <ng-container *ngIf="editingSunbedId !== sunbed.id">
                        <span class="chair-name">{{sunbed.type}}:<span class="text-decoration-underline">{{ sunbed.number }}</span></span>
                      </ng-container>
                      <span class="chair-budget">{{ sunbed.price?.toFixed(2) }} EUR</span>
                    </div>
                    <button
                      mat-icon-button
                      class="remove-btn"
                      (click)="$event.stopPropagation(); removeChairFromGroup(group.id, sunbed.id)"
                    >
                      <mat-icon class="remove-icon">close</mat-icon>
                    </button>
                  </div>

                </mat-chip>
              </div>
            </div>

            <!-- Contact Section -->
            <div class="detail-section">
              <div class="section-header">
                <h4>
                  <mat-icon>person</mat-icon>
                  Kontakt
                </h4>
              </div>
              <div class="form-row">
                <mat-form-field appearance="outline" class="form-field">
                  <mat-label>Kontakt osoba</mat-label>
                  <input
                    matInput
                    [(ngModel)]="group.contactPerson"
                    (ngModelChange)="onGroupUpdate(group.id, 'contactPerson', $event)"
                  />
                </mat-form-field>
                <mat-form-field appearance="outline" class="form-field">
                  <mat-label>Email</mat-label>
                  <input
                    matInput
                    [(ngModel)]="group.contactEmail"
                    (ngModelChange)="onGroupUpdate(group.id, 'contactEmail', $event)"
                  />
                </mat-form-field>
              </div>
            </div>

            <!-- Wristbands Section -->
            <div class="detail-section">
              <div class="section-header">
                <h4>
                  <mat-icon>watch</mat-icon>
                  Narukvice
                </h4>
                <button
                  mat-icon-button
                  class="add-wristband-toggle"
                  (click)="toggleWristbandInput(group.id)"
                  [hidden]="wristbandInputs[group.id]"
                >
                  <mat-icon>add</mat-icon>
                </button>
              </div>

              <!-- Wristband Input -->
              <div *ngIf="wristbandInputs[group.id]" class="wristband-input-container">
                <mat-form-field appearance="outline" class="wristband-input-field">
                  <mat-label>Unesi šifru narukvice</mat-label>
                  <input
                    matInput
                    [(ngModel)]="newWristbandInput[group.id]"
                    placeholder="Unesi šifru..."
                    (keydown.enter)="addChildWristband(group.id)"
                    [id]="'wristband-input-' + group.id"
                    [disabled]="wristbandLoading[group.id]"
                  />
                  <button
                    mat-icon-button
                    matSuffix
                    (click)="addChildWristband(group.id)"
                    [disabled]="!newWristbandInput[group.id]?.trim() || wristbandLoading[group.id]"
                    class="confirm-btn"
                  >
                    <mat-icon *ngIf="!wristbandLoading[group.id]">check</mat-icon>
                    <mat-spinner *ngIf="wristbandLoading[group.id]" diameter="20"></mat-spinner>
                  </button>
                  <button
                    mat-icon-button
                    matSuffix
                    (click)="cancelWristbandInput(group.id)"
                    [disabled]="wristbandLoading[group.id]"
                    class="cancel-btn"
                  >
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-form-field>
              </div>

              <!-- Wristbands List -->
              <div class="wristbands-list">
                <div
                  *ngFor="let wristband of group.childWristbands"
                  class="wristband-item"
                >
                  <div class="wristband-info">
                    <mat-icon class="wristband-icon">watch</mat-icon>
                    <span class="wristband-code">{{ wristband }}</span>
                  </div>
                  <button
                    mat-icon-button
                    class="remove-wristband-btn"
                    (click)="removeChildWristband(group.id, wristband)"
                  >
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
              </div>
            </div>

            <!-- Remove Group Button -->
            <div class="group-actions">
              <button
                mat-stroked-button
                color="warn"
                (click)="removeGroup(group.id)"
                class="btn-remove-group"
              >
                <mat-icon>delete</mat-icon>
                Ukloni grupu
              </button>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>

  <!-- Action Buttons -->
  <div class="action-buttons">
    <button mat-button (click)="onBack()" class="btn-back">
      <mat-icon>arrow_back</mat-icon>
      Natrag
    </button>
    <button
      mat-raised-button
      color="primary"
      [disabled]="!canContinue"
      (click)="onContinue()"
      class="btn-continue"
    >
      Nastavi
      <mat-icon>arrow_forward</mat-icon>
    </button>
  </div>

  <!-- Loading Overlay -->
  <app-loading
    *ngIf="loading"
    message="Check-In..."
    [overlay]="true"
  ></app-loading>
</div>
